import Channel from "./Channel";

export default class Suggestion extends Channel {
    static get entity () {
        return 'suggestions'
    }
}
